import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import CustomPDPVariantAddToCartState from "@tCentro/Store/Reducer/CustomPDPVariantAddToCartState";

import { Draft } from "immer";

const initialState: CustomPDPVariantAddToCartState = {
    variantPdpAddToCartClicked: false,
};

const reducer = {
    "Pages/CenProductDetails/CenVariantAddToCartisClicked": (draft: Draft<CustomPDPVariantAddToCartState>,action:{param:boolean}) => {
        draft.variantPdpAddToCartClicked = action.param;
    },

};

export default createTypedReducerWithImmer(initialState, reducer);

